import type { IProjectRepository } from "@domain/repositories";
import { TYPES } from "@utils/inversifyJS/types";
import { inject, injectable } from "inversify";
import type { MyProject } from "@domain/schemas/workspace";

@injectable()
export class ListProjectsService {
  @inject(TYPES.IProjectRepository)
  private _projectRepository!: IProjectRepository;

  async getMyProjectsAsync(): Promise<MyProject[]> {
    return this._projectRepository.getMyProjectsAsync();
  }

  /**
   * Client-side narrowing of {@link getMyProjectsAsync}. `GET /projects` has no
   * `teamId` parameter, and `GET /teams/{teamId}/projects` answers a different
   * question (the team's inventory, not the caller's access), so filtering here is
   * the only way to get "my projects in this team".
   */
  async getMyProjectsForTeamAsync(teamId: string): Promise<MyProject[]> {
    const projects = await this._projectRepository.getMyProjectsAsync();
    return projects.filter((project) => project.teamId === teamId);
  }
}
